import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=1f0bc404&scoped=true"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"
import style0 from "./Timer.vue?vue&type=style&index=0&id=1f0bc404&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0bc404",
  null
  
)

export default component.exports